module.exports = __webpack_public_path__ + "media/images/chevron-down-19063b89f609e1b8d11ca64cc3221612.svg";